import { render, staticRenderFns } from "./Trusted-customers.vue?vue&type=template&id=72d8e3c0"
import script from "./Trusted-customers.vue?vue&type=script&lang=js"
export * from "./Trusted-customers.vue?vue&type=script&lang=js"
import style0 from "./Trusted-customers.vue?vue&type=style&index=0&id=72d8e3c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports